document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".productSliderSwiper");
        MultipleSliders.forEach((slider) => {

            const secHeader = slider.closest(".prodCardSecRow").previousElementSibling;
            const prevArrow = secHeader.querySelector(".swiper-button-prev");
            const nextArrow = secHeader.querySelector(".swiper-button-next");
            const pagination = secHeader.querySelector(".swiper-pagination");

            const currentEl = document.createElement("span");
            currentEl.classList.add("swiper-current-num");
            currentEl.textContent = "01";

            const totalEl = document.createElement("span");
            totalEl.classList.add("swiper-total-num");

            pagination.before(currentEl);
            pagination.after(totalEl);

            const swiper = new Swiper(slider, {
                direction: "horizontal",
                speed: 1000,
                grabCursor: false,
                // allowTouchMove: false,
                loop: true,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                pagination: {
                    el: pagination,
                    type: "progressbar",
                },
                breakpoints: {
                    150: { slidesPerView: 1.75, spaceBetween: 10 },
                    576: { slidesPerView: 2., spaceBetween: 15 },
                    769: { slidesPerView: 3, spaceBetween: 20 },
                    1025: { slidesPerView: 4, spaceBetween: 20 }
                },
                on: {
                    init: function () {
                        const total = this.slides.length;
                        totalEl.textContent = String(total).padStart(2, "0");
                        currentEl.textContent = "01";
                    },
                    slideChange: function () {
                        const current = String(this.realIndex + 1).padStart(2, "0");
                        currentEl.textContent = current;
                    }
                }
            });
        });
    };

    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".limitedTimeSaleSlider");
        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".swiper-button-prev");
            const nextArrow = slider.parentElement.querySelector(".swiper-button-next");
            new Swiper(slider, {
                direction: "horizontal",
                speed: 1000,
                grabCursor: false,
                // allowTouchMove: false,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                breakpoints: {
                    150: {
                        slidesPerView: 1.75,
                        spaceBetween: 10,
                    },
                    576: {
                        slidesPerView: 2.2,
                        spaceBetween: 15,
                    },
                    769: {
                        slidesPerView: 2.1,
                        spaceBetween: 20,
                    },
                    1025: {
                        slidesPerView: 2.9,
                        spaceBetween: 20,
                    }
                },
            });
        });
    };
    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".testimonialSlider");
        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".swiper-button-prev");
            const nextArrow = slider.parentElement.querySelector(".swiper-button-next");
            new Swiper(slider, {
                direction: "horizontal",
                speed: 1000,
                grabCursor: false,
                // allowTouchMove: false,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                breakpoints: {
                    150: {
                        slidesPerView: 1.4,
                        spaceBetween: 10,
                    },
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    769: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    }
                },
            });
        });
    };
    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", () => {
  const c = document.querySelector(".LoopMarque");
  if (!c) return;

  const items = [...c.querySelectorAll(".slider__item")];
  if (!items.length) return;

  const imgs = [...c.querySelectorAll("img")];

  Promise.all(imgs.map(img => 
    img.complete ? Promise.resolve() : new Promise(r => {
      img.onload = img.onerror = r;
    })
  )).then(() => {
    const w = (c.parentElement || c).offsetWidth || window.innerWidth;
    const getW = els => els.reduce((t, el) => t + el.offsetWidth, 0);
    const baseW = getW(items);
    if (!baseW) return;

    const reps = Math.max(1, Math.ceil(w / baseW) + 1);

    for (let i = 0; i < reps * 2 - 1; i++) {
      items.forEach(el => c.appendChild(el.cloneNode(true)));
    }

    const dist = baseW * reps;
    const anim = gsap.to(c, {
      x: -dist,
      duration: dist / 40,
      ease: "linear",
      repeat: -1
    });

    c.addEventListener("mouseenter", () => anim.pause());
    c.addEventListener("mouseleave", () => anim.resume());
  });
});
